import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as Sentry from '@sentry/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
// import ErrorBoundary from 'src/components/ErrorBoundary';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import SnackbarGlobal from 'src/components/common/Snackbar';
import GlobalLoading from 'src/components/GlobalLoading';
import { queryClient } from 'src/configs/queryClient';
import 'src/sentry';
import ThemeCustomization from 'src/themes';
import './index.css';
import reportWebVitals from './reportWebVitals';

const LazyLoadingApp = React.lazy(() => import('src/App'));
const SentryApp = Sentry.withProfiler(LazyLoadingApp);

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Suspense fallback={<GlobalLoading />}>
    {/* <Sentry.ErrorBoundary
      fallback={({ error, componentStack, eventId }) => (
        <ErrorBoundary error={error} componentStack={componentStack} eventId={eventId} />
      )}
      showDialog={false}
    > */}
      <ThemeCustomization>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
              {(process.env.NODE_ENV === 'development' && (
                <>
                  <SentryApp />
                  <ReactQueryDevtools initialIsOpen={false} />
                </>
              )) || <LazyLoadingApp />}
              <SnackbarGlobal />
              <ToastContainer stacked />
            </PersistQueryClientProvider>
          </LocalizationProvider>
        </BrowserRouter>
      </ThemeCustomization>
    {/* </Sentry.ErrorBoundary> */}
  </React.Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
